import { Money } from "@flockcover/flock-svc-core-types"
import { Card, Flex, Title, SubTitle, CSSFn } from "@shared/primitive-components"
import moneyToString from "@shared/utils/formatters/moneyToString"
import * as styles from "./pricingPaneStyles"

export type PricingPaneProps = Readonly<{
  premium: Money
  children: React.ReactNode
  css?: CSSFn
}>

export const PricingPane = ({ premium, children, css }: PricingPaneProps) => (
  <Card css={styles.getRootStyle(css)}>
    <Flex justifyContent="space-between" alignItems="center" css={styles.titleWrap}>
      <SubTitle tag="h2">Premium</SubTitle>
      <Title tag="h2">{moneyToString(premium)}</Title>
    </Flex>

    {children}
  </Card>
)
